import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const gaEvent = (name, params = {}) => {
  if (window.gtag) window.gtag("event", name, { page_path: window.location.pathname, ...params });
};

const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("cac_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const authApi = {
  login: (password) => api.post("/auth/login", { password }),
};

export const leadsApi = {
  create: async (data) => {
    const r = await api.post("/leads", data);
    if (!window.location.pathname.startsWith("/owner")) gaEvent("generate_lead", { source: data.source || "" });
    return r;
  },
  list: (params) => api.get("/leads", { params }),
  stats: () => api.get("/leads/stats"),
  update: (id, data) => api.patch(`/leads/${id}`, data),
  remove: (id) => api.delete(`/leads/${id}`),
  bulk: (rows) => api.post("/leads/bulk", { rows }),
  requestReview: (id) => api.post(`/leads/${id}/request-review`),
};

export const applicationsApi = {
  create: async (data) => {
    const r = await api.post("/applications", data);
    gaEvent("job_application", {});
    return r;
  },
};

export const payersApi = {
  publicList: () => api.get("/payers/public"),
  list: () => api.get("/payers"),
  create: (data) => api.post("/payers", data),
  update: (id, data) => api.patch(`/payers/${id}`, data),
  remove: (id) => api.delete(`/payers/${id}`),
};

export const reviewsApi = {
  publicList: () => api.get("/reviews/public"),
  list: () => api.get("/reviews"),
  create: (data) => api.post("/reviews", data),
  update: (id, data) => api.patch(`/reviews/${id}`, data),
  remove: (id) => api.delete(`/reviews/${id}`),
};

export const emailApi = {
  send: (data) => api.post("/send-email", data),
  sendBulk: (data) => api.post("/send-bulk-email", data),
};

export const growthApi = {
  counties: () => api.get("/growth/counties"),
  updateCounty: (id, data) => api.patch(`/growth/counties/${id}`, data),
  priorities: () => api.get("/growth/priorities"),
  publicCounty: (slug) => api.get(`/growth/county/${slug}`),
  funnel: () => api.get("/growth/funnel"),
  familyCaregiverCreate: (data) => api.post("/family-caregiver", data),
  fcList: () => api.get("/growth/family-caregiver"),
  fcUpdate: (id, data) => api.patch(`/growth/family-caregiver/${id}`, data),
  contentList: () => api.get("/growth/content"),
  contentCreate: (d) => api.post("/growth/content", d),
  contentUpdate: (id, d) => api.patch(`/growth/content/${id}`, d),
  contentRemove: (id) => api.delete(`/growth/content/${id}`),
  availabilityList: () => api.get("/growth/availability"),
  availabilityCreate: (d) => api.post("/growth/availability", d),
  availabilityUpdate: (id, d) => api.patch(`/growth/availability/${id}`, d),
  availabilityRemove: (id) => api.delete(`/growth/availability/${id}`),
  acquisition: () => api.get("/growth/acquisition"),
  actions: () => api.get("/growth/actions"),
  runReminders: () => api.post("/growth/run-reminders"),
  sendDigest: () => api.post("/growth/send-digest"),
};

export const outreachApi = {
  settings: () => api.get("/outreach/settings"),
  updateSettings: (d) => api.patch("/outreach/settings", d),
  testEmail: (to) => api.post("/outreach/test-email", { to }),
  runDaily: () => api.post("/outreach/run-daily"),
  dashboard: () => api.get("/outreach/dashboard"),
  activity: () => api.get("/outreach/activity"),
  contacts: () => api.get("/outreach/contacts"),
  createContact: (d) => api.post("/outreach/contacts", d),
  updateContact: (id, d) => api.patch(`/outreach/contacts/${id}`, d),
  removeContact: (id) => api.delete(`/outreach/contacts/${id}`),
  keywords: () => api.get("/outreach/keywords"),
  createKeyword: (d) => api.post("/outreach/keywords", d),
  updateKeyword: (id, d) => api.patch(`/outreach/keywords/${id}`, d),
};

export const track = (type, county = "") => {
  try {
    api.post("/track", { type, county, path: window.location.pathname }).catch(() => {});
  } catch {}
};

export default api;
